import { adminAreaQueryKeys as e } from "./adminAreaQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { adminAreaApi as r } from "@maat/api-main";
//#region src/areas/admin/useUpdateAreaMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: ({ id: e, data: t }) => r.updateArea(e, t),
		onSuccess: () => {
			i.invalidateQueries({ queryKey: e.list() });
		}
	});
};
//#endregion
export { i as useUpdateAreaMutation };
